<template>
    <div v-for="(items, index) in dataObj" :key="index" class="pb-5">
        <b-row>
            <div class="d-flex mt-3">
                <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">

                <!-- <p>{{ index + 1 }}</p> -->
                <h6 class="bold-heading mt6 ms-1 me-2">{{ index + 1 }}</h6>

                <h6 class="bold-heading mt6 ms-1">{{ $t('ContactDetails.title') }}</h6>
            </div>
        </b-row>
        <b-row class="my-2 ps-3">
            <!-- {{ items }} -->
            <b-col sm="10" md="10" lg="10">
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('ContactDetails.vendors') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ items.ContactPerson }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('ContactDetails.designation') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ items.ContactDesignation }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('ContactDetails.email') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ items.Email }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('ContactDetails.phone') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ items.Phone }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="5" sm="5" cols="12" class="form-field-column">
                        <label class="display-field-label">{{ $t('ContactDetails.website') }}</label>
                    </b-col>
                    <b-col lg="8" md="7" sm="7" cols="12" class="form-field-column">
                        <p class="details-black-field">{{ items.Web }}</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface ContactDetails {
    ContactPerson?: string;
    ContactDesignation?: string;
    Email?: string;
    Phone?: string;
    Web?: string;
}

export default defineComponent({
    props: {
        dataObj: {
            type: Array as () => ContactDetails[],
            default: () => []
        }
    }
});
</script>

<style lang="scss"></style>
